/**
 * CaseFlow+AI - Language Switcher Component
 * Compact language toggle for topbar, placed next to theme toggle
 */

import React from 'react';
import { useLanguage } from '../../i18n/LanguageProvider';
import { SUPPORTED_LANGUAGES } from '../../i18n';
import { useTheme } from '../../theme/ThemeProvider';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage } = useLanguage();
  const { theme } = useTheme();

  const currentLang = SUPPORTED_LANGUAGES.find(l => l.code === language);
  const otherLang = SUPPORTED_LANGUAGES.find(l => l.code !== language);

  if (!currentLang || !otherLang) return null;

  const handleToggle = () => {
    setLanguage(otherLang.code);
  };

  // Compact styling that matches theme toggle
  const baseClasses = `
    px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200
    flex items-center gap-1.5
    border
  `;

  const themeClasses = theme === 'dark' 
    ? 'bg-gray-700 border-gray-600 text-gray-200 hover:bg-gray-600 hover:border-gray-500'
    : 'bg-gray-100 border-gray-200 text-gray-700 hover:bg-gray-200 hover:border-gray-300';

  const activeClasses = theme === 'dark'
    ? 'text-blue-400'
    : 'text-blue-600';

  return (
    <button
      onClick={handleToggle}
      className={`${baseClasses} ${themeClasses}`}
      aria-label={`Byt språk till ${otherLang.nativeName}`}
      title={`Byt språk till ${otherLang.nativeName}`}
    >
      <span className="text-base">
        {language === 'sv' ? '🇸🇪' : '🇬🇧'}
      </span>
      <span className={`hidden sm:inline ${activeClasses}`}>
        {language === 'sv' ? 'SV' : 'EN'}
      </span>
      <span className="text-gray-400 mx-0.5">|</span>
      <span className="text-gray-400">
        {language === 'sv' ? 'EN' : 'SV'}
      </span>
    </button>
  );
};

export default LanguageSwitcher;
